import { RootState } from 'src/store/store';
import { useSelector } from 'react-redux';
import NewPrescriptionForm from '../prescription-form/NewPrescriptionForm';

const AddNewPrescription = () => {
    const currentProduct = useSelector((state: RootState) => state.contacts.currentProduct);

    return (
        <div className="contact-lens-prescription logged-select-prescription">
            {!!currentProduct && <NewPrescriptionForm />}
        </div>
    );
};

export default AddNewPrescription;
